import { createClient } from 'contentful';
import _ from 'lodash';
import { SUPPORT, COMMON } from 'app/route-constants';
import { contentfulModels } from '@glowforge/ui-common';

const { getContentfulGlobalFooterProps } = contentfulModels;

let contentfulClient;

function initClient(credentials) {
  contentfulClient = createClient(credentials);
  return contentfulClient.getSpace()
    .then(contentfulSpace => contentfulSpace);
}

function getContentfulClient() {
  if (!contentfulClient) {
    initClient(sharedEnv.CONTENTFUL_CLIENT_CONFIG);
  }
  return contentfulClient;
}

function unpackPages(entries) {
  if (!entries.items || entries.items.length === 0) {
    throw new Error(COMMON.PAGE_ERRORS.PAGE_NOT_FOUND);
  }
  return entries.items;
}

/**
 * Normalizes the data returned from Contentful for an entry representing a single page.
 * @param {Object} entries Contentful Entry objects
 */
function unpackPage(entries) {
  return unpackPages(entries)[0];
}

// ** Support Article for Onboarding ** //
export const getSupportArticle = slug => (
  getContentfulClient().getEntries({
    include: 2,
    content_type: 'supportArticle',
    'fields.slug': slug,
  }).then((entries) => {
    if (!entries.items || entries.items.length === 0) {
      throw new Error(COMMON.PAGE_ERRORS.PAGE_NOT_FOUND);
    }
    return entries.items[0];
  })
);

export const getPage = id => (
  getContentfulClient().getEntries({
    include: 4,
    content_type: 'page',
    'fields.id': id,
  }).then(unpackPage)
);

export const getStandalonePageBySlug = slug => (
  getContentfulClient().getEntries({
    include: 4,
    content_type: 'page',
    'fields.slug': slug,
  }).then((entries) => {
    // Contentful client doesn't support filtering for more than one content type
    const page = unpackPage(entries);
    if (_.get(page, 'fields.pageType') !== 'standalone') {
      throw new Error(COMMON.PAGE_ERRORS.PAGE_NOT_FOUND);
    }
    return page;
  })
);

// TODO: Figure out how to do individual calls
export const getLegalPages = () => (
  getContentfulClient().getEntries({
    include: 1,
    content_type: 'legalPage',
  }).then(unpackPages)
);

export const getUserInviteAcceptPage = () => (
  getContentfulClient().getEntries({
    include: 1,
    content_type: 'userInviteLanding',
  }).then(unpackPage)
);

export const getGlobalFooter = () => getContentfulClient().getEntries({
  include: 4,
  content_type: 'section',
  'fields.id': 'global-footer',
})
  .then(entries => (entries.items.length ? entries.items[0] : {}))
  .then(result => getContentfulGlobalFooterProps(result));

export const getDefaultMetadata = () => (
  getContentfulClient().getEntries({
    include: 4,
    content_type: 'pageMetadata',
    'fields.id': 'default-metadata',
  }).then(entries => (entries.items.length ? entries.items[0] : {}))
);

export const getJobs = () => (
  getContentfulClient().getEntries({
    include: 1,
    content_type: 'job',
  }).then(unpackPages)
);

export const getJobDescriptionPage = slug => (
  getContentfulClient().getEntries({
    include: 1,
    content_type: 'job',
    'fields.slug': slug,
  }).then(unpackPage)
);

export const getGlowforgeComparisonChart = () => (
  getContentfulClient().getEntries({
    include: 2,
    content_type: 'glowforgeComparisonChart',
    'fields.lookupId': 'glowforgeFamilyComparisonChart',
  }).then(unpackPage)
);

export const getTextString = id => (
  getContentfulClient().getEntries({
    include: 1,
    content_type: 'textString',
    'fields.id': id,
  }).then(unpackPage)
);



// WEBPACK FOOTER //
// ./app/api/contentful-client.js